export default __webpack_public_path__ + "static/media/noa-4.0a7b9f58.jpg";